import { Tab, Tabs, Box, Button, Menu, MenuItem, IconButton } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Book, MoreVert } from "@mui/icons-material";
import TariffMaster from "../../Components/CreateTariff/TariffMaster";
import SearchTable from "../../Components/Common/Component/SearchTable";
import TariffSearchFilter from "../../Components/Common/Component/TariffSearchFilter";
import CorporateClientInput from "../../Components/CorporateClient/CorporateClientInput";
import CreateEditPackageDrawerForm from "../../Components/FormsTariff/CreateEditPackageDrawerForm";
import RateInput from "../../Components/Rates/RateInput";
import FilterTable from "../../Components/Common/Component/FilterTable";
import { useTariffSearch } from "../../_helper/TariffSearchContext/TariffSeachContext";
import { packageFilterColumns } from "../../Data/Configuration/Packages";
import SelectedFilter from "../../Components/TripManagement/BookingHistory/SelectedFilter";
import { Row } from "reactstrap";
import { rateFilterColumns } from "../../Data/Configuration/Rates";
import SharedDataContext from "../../_helper/SharedData";
import { getPackagesByCorporateClientIds } from "../../Services/Packages.service";
import { showAlert } from "../../Services/Shared.service";

function ViewTariffLayout() {
  const {
    searchData,
    setSearchData,
    filterData,
    setFilterData,
    filterType,
    setFilterType,
    closeInputModal,
    setCloseInputModal,
    openPackageFlow,
    setOpenPackageFlow,
    bulkEditMode,
    setBulkEditMode,
    selectedPackages,
    setSelectedPackages,
    corpBulkEditMode,
    setCorpBulkEditMode,
    selectedCorpClients,
    setSelectedCorpClients
  } = useTariffSearch();
  const location = useLocation();
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [isOpenCreateClientModal, setIsOpenCreateClientModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null); // Menu anchor for packages tab
  const [isCreatePackageDrawerOpen, setIsCreatePackageDrawerOpen] =
    useState(false);
  const { globalCityField, allCityData, airportData } = useContext(SharedDataContext);
  const [isEditRate, setIsEditRate] = useState(false);
  const [flowType, setFlowType] = useState(null);
  const openFlow = (type) => {
    setFlowType(type);
    setModal(true);
    setCloseInputModal(true);
  };
  const closeFlow = () => {
    setModal(false);
    setFlowType(null);
    setCloseInputModal(false);
    setOpenPackageFlow(false); // Reset the trigger
  };

  // Menu handlers for packages tab
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Bulk edit handlers
  const handleBulkEditClick = () => {
    handleMenuClose();
    setBulkEditMode(true);
    setSelectedPackages([]);
  };

  const handleCancelBulkEdit = () => {
    handleMenuClose();
    setBulkEditMode(false);
    setSelectedPackages([]);
  };

  const handleProceedBulkEdit = () => {
    handleMenuClose();
    if (selectedPackages.length > 0) {
      sessionStorage.setItem('packageBulkEditAccess', 'true');
      navigate(`${process.env.PUBLIC_URL}/tariff_master/bulk-edit`, {
        state: { packages: selectedPackages, source: 'packages' }
      });
    }
  };

  // Corp bulk edit handlers
  const handleCorpBulkEditClick = () => {
    handleMenuClose();
    setCorpBulkEditMode(true);
    setSelectedCorpClients([]);
  };

  const handleCancelCorpBulkEdit = () => {
    handleMenuClose();
    setCorpBulkEditMode(false);
    setSelectedCorpClients([]);
  };

  const handleProceedCorpBulkEdit = () => {
    handleMenuClose();
    if (selectedCorpClients.length > 0) {
      const clientIds = selectedCorpClients.map(client => client.id);
      console.log(selectedCorpClients)
      getPackagesByCorporateClientIds(clientIds)
        .then(response => {
          console.log(response)
          if (response?.data && response.data.list.length > 0) {
            sessionStorage.setItem('corpBulkEditAccess', 'true');
            setCorpBulkEditMode(false);
            setSelectedCorpClients([]);
            navigate(`${process.env.PUBLIC_URL}/tariff_master/bulk-edit`, {
              state: { packages: response.data.list, source: 'corp' }
            });
          } else {
            showAlert('warning', 'No packages found for selected Corporate clients');
          }
        })
        .catch(error => {
          console.error('Error fetching packages:', error);
          showAlert('error', 'Failed to fetch packages for selected Corporate clients');
        });
    }
  };

  // Listen for openPackageFlow trigger child components
  useEffect(() => {
    if (openPackageFlow) {
      openFlow("package");
    }
  }, [openPackageFlow]);
  const tabs = [
    { label: "Clients", path: "corp" },
    { label: "Packages", path: "packages" },
    { label: "Rates", path: "meter" },
  ];

  // Check if we're on a child/detail route (hide bulk edit menu items on detail pages)
  const isChildRoute = location.pathname.includes('/info/') ||
    /\/packages\/\d+/.test(location.pathname);

  // Derive selected tab from URL
  const getCurrentTabIndex = () => {
    const pathname = location.pathname;
    const basePath = `${process.env.PUBLIC_URL}/tariff_master/view`;

    // Check if we're on a child route (e.g., /corp/info/:id)
    for (let i = 0; i < tabs.length; i++) {
      const tabPath = tabs[i].path;
      // Match base tab or any child route starting with tab path
      if (
        pathname === `${basePath}/${tabPath}` ||
        pathname.startsWith(`${basePath}/${tabPath}/`)
      ) {
        return i;
      }
    }

    // Default to first tab if no match
    return 0;
  };

  const [tabTariff, setTabTariff] = useState(getCurrentTabIndex());

  // Sync tab state when URL changes
  useEffect(() => {
    const currentIndex = getCurrentTabIndex();
    if (currentIndex !== tabTariff) {
      setTabTariff(currentIndex);
      setSearchData("");
      setFilterData([]);
      setFilterType("");
    }
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setTabTariff(newValue);
    setSearchData("");
    setFilterData([]);
    setFilterType("");
    const basePath = `${process.env.PUBLIC_URL}/tariff_master/view`;
    navigate(`${basePath}/${tabs[newValue].path}`, { replace: false });
  };

  const removeFilter = (index) => {
    const newfilterData = [...filterData];
    newfilterData.splice(index, 1);
    setFilterData(newfilterData);
  };

  // Get car types for the selected city
  const getCarTypeData = () => {
    if (!allCityData) return [];

    // If NO city is selected → return ALL car types from ALL cities
    if (!globalCityField?.value?.id) {
      const allCars = allCityData.flatMap(city => city.carType || []);

      // Remove duplicates by car.id
      const uniqueCars = Array.from(
        new Map(allCars.map(car => [car.id, car])).values()
      );

      return uniqueCars.map(car => ({
        value: car.id,
        label: car.name
      }));
    }

    // If city selected → return only that city’s car types
    const selectedCity = allCityData.find(
      city => city.id === globalCityField.value.id
    );

    if (!selectedCity?.carType) return [];

    return selectedCity.carType.map(car => ({
      value: car.id,
      label: car.name
    }));
  };


  const carTypeData = getCarTypeData();

  // Get terminals/airports for the selected city
  const getTerminalData = () => {
    if (!airportData) return [];

    // If NO city is selected → return ALL airports
    if (!globalCityField?.value?.id) {
      return airportData.map(airport => ({
        value: airport.shortName,
        label: airport.name
      }));
    }

    // If city selected → return only that city's airports
    const cityAirports = airportData.filter(
      airport => airport.serviceCityId === globalCityField.value.id
    );

    return cityAirports.map(airport => ({
      value: airport.shortName,
      label: airport.name
    }));
  };

  const terminalData = getTerminalData();
  // let pickupTypeData = [
  //   {
  //     value: "a2c",
  //     label: "AirportToCity",
  //   },
  //   {
  //     value: "c2a",
  //     label: "CityToAirport",
  //   },
  // ];

  let clientTypeData = [
    {
      value: "api",
      label: "Api",
    },
    {
      value: "nonApi",
      label: "Non-Api",
    },
  ];

  const clientFilterColumns = [
    // {
    //   name: "Pickup Type",
    //   value: "pickup_type",
    //   type: "select",
    // },
    {
      name: "Client Type",
      value: "client_type",
      type: "select",
    },
  ];

  const bookingSourceData = [
    { value: "Partner", label: "Partner" },
    { value: "Customer", label: "Customer" },
    { value: "Kiosk", label: "Kiosk" },
    { value: "Website", label: "Website" },
    { value: "TMS", label: "TMS" },
    { value: "ThirdParty", label: "ThirdParty" },
    { value: "ALL", label: "ALL" },
  ]

  const rideTypeData = [
    { value: "RideLater", label: "C2A" },
    { value: "KurbPickup", label: "KurbPickup" },
    { value: "AirportPickup", label: "A2C" },
    { value: "ALL", label: "ALL" },
  ]
  const formatColumns = (columns) => {
    return columns.map((col) => ({
      value: {
        name: col.name,
        value: col.value,
        type: col.type,
      },
      label: col.name,
    }));
  };

  const formattedClientColumns = formatColumns(clientFilterColumns);
  const formattedPackageColumns = formatColumns(packageFilterColumns);
  const formattedRateColumns = formatColumns(rateFilterColumns);

  const cancelButtonStyle = {
    color: "rgba(172, 45, 45, 1)",
    border: "1px solid rgba(181, 57, 57, 1)",
    borderRadius: "6px",
    backgroundColor: "rgba(244, 225, 225, 1)",
    height: "3.06vw",
    fontSize: "1.11vw",
    padding: "0.69vw 0.97vw",
    textTransform: "none",
    "&:hover": {
      color: "rgba(251, 0, 0, 1)",
      backgroundColor: "rgba(244, 225, 225, 1)",
      borderColor: "#cc4141ff",
    },
  };
  const proceedButtonStyle = {
    color: "rgba(57, 181, 74, 1)",
    border: "1px solid rgba(57, 181, 74, 1)",
    borderRadius: "6px",
    backgroundColor: "rgba(225, 244, 228, 1)",
    height: "3.06vw",
    fontSize: "1.11vw",
    padding: "0.69vw 0.97vw",
    textTransform: "none",
    "&:hover": {
      color: "rgba(57, 181, 74, 1)",
      backgroundColor: "rgba(225, 244, 228, 1)",
      borderColor: "#41CC7D",
    },
  };

  return (
    <Box sx={{ width: "100%", paddingTop: 3, minHeight: "100vh" }}>
      {/* <TariffMaster modal={modal} setModal={setModal} /> */}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginX: "1.2vw",
        }}
      >
        <Tabs
          value={tabTariff}
          onChange={handleChange}
          sx={{
            "& .MuiTabs-flexContainer": {
              display: "flex",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "rgba(57, 181, 74, 1)",
              height: "3px",
              display: "flex",
              justifyContent: "center",
            },
            "& .MuiTabs-indicatorSpan": {
              maxWidth: "100%",
              width: "100%",
            },
            "& .MuiTab-root.Mui-selected": {
              color: "rgba(57, 181, 74, 1)",
              fontWeight: 600,
            },
          }}
          TabIndicatorProps={{
            children: <span className="MuiTabs-indicatorSpan" />,
          }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.path}
              label={tab.label}
              sx={{
                padding: 0,
                textTransform: "none",
                fontSize: "1.39vw",
                letterSpacing: 0.3,
                fontWeight: 400,
                minWidth: "auto",
                mr: "2vw",
              }}
            />
          ))}
        </Tabs>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "1vw",
          }}
        >
          {tabTariff == 0 ? (
            corpBulkEditMode ? (
              <Box sx={{ display: "flex", gap: 1 }}>
                {selectedCorpClients.length > 0 && (
                  <Button
                    onClick={handleProceedCorpBulkEdit}
                    variant="outlined"
                    sx={proceedButtonStyle}
                  >
                    Proceed
                  </Button>
                )}
                <Button
                  onClick={handleCancelCorpBulkEdit}
                  variant="outlined"
                  sx={cancelButtonStyle}
                >
                  Cancel
                </Button>
              </Box>
            ) : null
          ) : tabTariff == 1 ? (
            bulkEditMode ? (

              <Box sx={{ display: "flex", gap: 1 }}>
                {selectedPackages.length > 0 && (
                  <Button
                    onClick={handleProceedBulkEdit}
                    variant="outlined"
                    sx={proceedButtonStyle}
                  >
                    Proceed
                  </Button>
                )}
                <Button
                  onClick={handleCancelBulkEdit}
                  variant="outlined"
                  sx={cancelButtonStyle}
                >
                  Cancel
                </Button>

              </Box>
            ) : null
          ) : (
            <Button
              sx={{
                color: "rgba(57, 181, 74, 1)",
                border: "1px solid rgba(57, 181, 74, 1)",
                borderRadius: "6px",
                backgroundColor: "rgba(225, 244, 228, 1)",
                width: "10.83vw",
                height: "3.06vw",
                fontSize: "1.11vw",
                padding: "0.69vw 0.97vw",
                "&:hover": {
                  color: "rgba(57, 181, 74, 1)",
                  backgroundColor: "#rgba(225, 244, 228, 1)",
                  borderColor: "#41CC7D",
                },
              }}
              onClick={() =>
                // setIsEditRate(true)
                openFlow("rate")
              }
              variant="outlined"
            >
              CREATE RATES
            </Button>
          )}
          <Box>
            {tabTariff == 2 ? null : (
              <TariffSearchFilter
                searchData={searchData}
                setSearchData={setSearchData}
                setFilterData={setFilterData}
                setFilterType={setFilterType}
              />
            )}
          </Box>
          <FilterTable
            options={
              tabTariff == 0
                ? formattedClientColumns
                : tabTariff == 1
                  ? formattedPackageColumns
                  : formattedRateColumns
            }
            // common props
            setFilterData={setFilterData}
            filterData={filterData}
            setSearchData={setSearchData}
            setFilterType={setFilterType}
            // tab-specific props
            // pickupTypeData={pickupTypeData}
            clientTypeData={clientTypeData}
            rideTypeData={rideTypeData}
            bookingSourceData={bookingSourceData}
            carTypeData={carTypeData}
          // terminalData={terminalData}
          />
          {/* Options menu for packages tab - positioned at rightmost */}
          {tabTariff == 1 && !bulkEditMode && (
            <>
              <IconButton
                onClick={handleMenuOpen}
                sx={{
                  border: "1px solid rgba(217, 217, 217, 1)",
                  borderRadius: "6px",
                  padding: "8px",
                  "&:hover": {
                    backgroundColor: "rgba(225, 244, 228, 1)",
                    borderColor: "#41CC7D",
                  },
                }}
              >
                <MoreVert />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                disableScrollLock={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: "180px",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                  },
                }}
              >
                {/* <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    openFlow("package");
                  }}
                  sx={{
                    color: "rgba(57, 181, 74, 1)",
                    "&:hover": { backgroundColor: "rgba(225, 244, 228, 1)" },
                  }}
                >
                  Create Package
                </MenuItem> */}
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    openFlow("packagesBulkCreate");
                  }}
                  sx={{
                    color: "rgba(57, 181, 74, 1)",
                    "&:hover": { backgroundColor: "rgba(225, 244, 228, 1)" },
                  }}
                >
                  Create Packages
                </MenuItem>
                {!isChildRoute && (
                  <MenuItem
                    onClick={handleBulkEditClick}
                    sx={{
                      color: "rgba(57, 181, 74, 1)",
                      "&:hover": { backgroundColor: "rgba(225, 244, 228, 1)" },
                    }}
                  >
                    Edit Packages Rates
                  </MenuItem>
                )}
              </Menu>
            </>
          )}
          {/* Options menu for clients tab - positioned at rightmost */}
          {tabTariff == 0 && !corpBulkEditMode && (
            <>
              <IconButton
                onClick={handleMenuOpen}
                sx={{
                  border: "1px solid rgba(217, 217, 217, 1)",
                  borderRadius: "6px",
                  padding: "8px",
                  "&:hover": {
                    backgroundColor: "rgba(225, 244, 228, 1)",
                    borderColor: "#41CC7D",
                  },
                }}
              >
                <MoreVert />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                disableScrollLock={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: "180px",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                  },
                }}
              >
                {/* <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    openFlow("client");
                  }}
                  sx={{
                    color: "rgba(57, 181, 74, 1)",
                    "&:hover": { backgroundColor: "rgba(225, 244, 228, 1)" },
                  }}
                >
                  Create Client
                </MenuItem> */}

                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    openFlow("clientsBulkCreate");
                  }}
                  sx={{
                    color: "rgba(57, 181, 74, 1)",
                    "&:hover": { backgroundColor: "rgba(225, 244, 228, 1)" },
                  }}
                >
                  Create Clients
                </MenuItem>
                {!isChildRoute && (
                  <MenuItem
                    onClick={handleCorpBulkEditClick}
                    sx={{
                      color: "rgba(57, 181, 74, 1)",
                      "&:hover": { backgroundColor: "rgba(225, 244, 228, 1)" },
                    }}
                  >
                    Edit Packages Rates
                  </MenuItem>
                )}
              </Menu>
            </>
          )}
        </Box>
      </Box>

      {/* This is where tab content + child pages render */}
      <Box sx={{ width: "100%", padding: 2 }}>
        <Row className="selected-filter">
          {filterData.map((element, i) => {
            return (
              <SelectedFilter
                key={i}
                element={element}
                index={i}
                removeFilter={removeFilter}
              />
            );
          })}
        </Row>
        <Outlet />
        <TariffMaster
          modal={modal}
          setModal={() => closeFlow()}
          flowType={flowType}
        />
      </Box>
    </Box>
  );
}

export default ViewTariffLayout;
